/**
 * @brisa/ui · facelift/section-title/SectionTitle
 *
 * Feature: migracao-facelift-v1 · COMPONENT_MAP §1 #5 (section-title)
 * Figma origem: node 163:918 (variante reforma 179:308 — Bruno 2026-05-14)
 *
 * Pattern tipográfico: heading Archivo Medium 20px text-black + trailing slot
 * (default: Button variant="secondary-pill" size="sm"). SEM eyebrow per PL
 * (reforma). Sem 'use client' — apresentacional puro (F1-RSC-11).
 */
import * as React from 'react';

import { cn } from '@brisa/ui/lib/utils';

export interface SectionTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  heading: React.ReactNode;
  trailing?: React.ReactNode;
  as?: 'h2' | 'h3' | 'h4';
}

export function SectionTitle({
  heading,
  trailing,
  as: Heading = 'h2',
  className,
  ...props
}: SectionTitleProps) {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-between gap-4',
        className,
      )}
      {...props}
    >
      <Heading
        data-slot="heading"
        className="font-body text-xl font-medium leading-tight text-[hsl(var(--text-100))]"
      >
        {heading}
      </Heading>
      {trailing ? <div data-slot="trailing">{trailing}</div> : null}
    </div>
  );
}
